/**
 * Gets named parameter from window location params
 * @param  {String} parameter Parameter key name.
 * @return {String}           Parameter value.
 * @return {Bool}             False if no parameter found.
 */
function getUrlParameters(parameter){
  var params = window.location.search.substr(1).split('&');

  for (var i = 0; i < params.length; i++) {
    var p=params[i].split('=');
    if (p[0] == parameter) {
      return decodeURIComponent(p[1]);
    }
  }
  return false;
}

module.exports = getUrlParameters;
